// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 269 ? "exifr" : chunkId) + "-legacy." + {"269":"35924227","764":"7db0e510","980":"5c102e3f"}[chunkId] + ".js";
};